/* eslint-disable react-hooks/exhaustive-deps */
import { RefObject, useEffect, useRef, useState } from 'react';
import './../style.css';
import { GetRequest, PostRequest } from '../../../includes/functions';
import { VehicleProps } from '../../../includes/types';
import { QRCode } from 'react-qrcode-logo';
import { BaseLoader } from '../../../components/baseloader';
import {
  BaseButton,
  LightYellowButton,
  PinkButton,
  WhiteButton,
} from '../../../components/buttons';
import { CONSTANTS } from '../../../includes/constant';
import { GoBackIcon } from '../../../assets/icons/BackIcon';
import EditIcon from '../../../assets/icons/editIcon';
import { TrashIcon } from '../icon';
import { DownloadIcon } from '../../../assets/icons/DownloadBtn';
import { toast } from 'react-toastify';
import { CopyIcon } from '../components/QrCode';
import html2canvas from 'html2canvas';
import { EditVehicleComponent } from '../components/editVehicle';
import { useNavigate } from 'react-router-dom';
import { ConfirmDialogComponent } from '../components/confirmDialog';
interface VehicleDetailsSectionProp {
  id: string;
}

export default function VehicleDetailsSection(
  props: VehicleDetailsSectionProp
) {
  const [showDeleteVehicle, setShowDeleteVehicle] = useState<boolean>(false);
  const [downloading, setDownLoading] = useState<boolean>(false);
  const thisQrcode = useRef() as RefObject<HTMLDivElement>;
  const [loadingPage, setLoadingPage] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [editVehicle, setShowEditVehicle] = useState<VehicleProps | null>(null);
  const [vehicleDetails, setVehicleDetails] = useState<VehicleProps | null>(
    null
  );

  const GetVehicleDetails = () => {
    setLoadingPage(true);
    GetRequest(`${props.id}`, {}, false).then((res) => {
      setLoadingPage(false);
      if (res.status) {
        setVehicleDetails(res.data.vehicles);
      }
    });
  };
  useEffect(() => {
    // GetVehicleDetails();
    const details: string | null = localStorage.getItem(
      CONSTANTS.Routes.Vehicles
    );
    if (details) {
      setVehicleDetails(JSON.parse(details));
    }
  }, []);

  const navigate = useNavigate();

  const exportAsImage = async (el: HTMLDivElement, imageFileName: string) => {
    setDownLoading(true);
    const canvas = await html2canvas(el);
    setDownLoading(false);
    const image = canvas.toDataURL('image/png', 1.0);
    // download the image
    downloadImage(image, imageFileName);
  };

  const downloadImage = (blob: any, fileName: string) => {
    const fakeLink: HTMLAnchorElement = window.document.createElement('a');
    fakeLink.style.display = 'none';
    fakeLink.download = fileName;
    fakeLink.href = blob;
    document.body.appendChild(fakeLink);
    fakeLink.click();
    document.body.removeChild(fakeLink);
    fakeLink.remove();
  };

  const CopyLnk = (copyText: string) => {
    navigator.clipboard.writeText(copyText);
    toast.success('Link copied', {
      position: toast.POSITION.TOP_CENTER,
    });
  };

  const DeleteVehicle = () => {
    setLoading(true);
    PostRequest(`put:vehicle/${vehicleDetails?._id}`, {}, true).then((res) => {
      setLoading(false);
      if (res.status) {
        setShowDeleteVehicle(false);
        navigate(CONSTANTS.Routes.Vehicles, { relative: 'path' });
      }
    });
  };

  return (
    <div style={{ position: 'relative' }}>
      <div className="main-scrollable p-5 pt-0">
        <div className="row">
          <div className="col-8 pb-5">
            <LightYellowButton to={'../' + CONSTANTS.Routes.Vehicles}>
              <GoBackIcon color="#F8B02B" size={15} />
              <span className="ps-2">Go back</span>
            </LightYellowButton>
            <span className="ps-3">Vehicle details</span>
          </div>
          <div className="col-4">
            <BaseButton
              onClick={() => {
                setShowEditVehicle(vehicleDetails);
              }}
            >
              <EditIcon />
              <span className="px-2">Edit details</span>
            </BaseButton>
            <PinkButton
              onClick={() => {
                setShowDeleteVehicle(true);
              }}
              style={{ marginLeft: 20, color: '#B00020' }}
            >
              <TrashIcon size={35} />
              <span className="px-0">Delete</span>
            </PinkButton>
          </div>
        </div>
        {loadingPage && (
          <div>
            <BaseLoader />
            <span className="ps-2">Loading</span>
          </div>
        )}
        <div className="row">
          <div className="col-7">
            <table className="table table-borderless">
              <tbody>
                <tr>
                  <td>Vehicle make</td>
                  <td className="text-end">{vehicleDetails?.make!}</td>
                </tr>
                <tr>
                  <td>Vehicle model</td>
                  <td className="text-end">{vehicleDetails?.vehicleModel!}</td>
                </tr>
                <tr>
                  <td>Vehicle year</td>
                  <td className="text-end">{vehicleDetails?.year!}</td>
                </tr>
                <tr>
                  <td>Registration number</td>
                  <td className="text-end">
                    {vehicleDetails?.registrationNumber!}
                  </td>
                </tr>
                <tr>
                  <td>Chassis number</td>
                  <td className="text-end">{vehicleDetails?.chasisNumber!}</td>
                </tr>
                <tr>
                  <td>Vehicle tag</td>
                  <td className="text-end">{vehicleDetails?.tag!}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-5">
            <div className="d-flex align-items-center justify-content-center">
              <div
                className="qrcode-wrp"
                ref={thisQrcode}
                style={{ borderRadius: 10 }}
              >
                <div
                  className="qrcode-inner d-flex align-items-center justify-content-center"
                  style={{ borderRadius: 10 }}
                >
                  <QRCode
                    value={JSON.stringify({
                      make: vehicleDetails?.make,
                      number: vehicleDetails?.registrationNumber,
                      tag: vehicleDetails?.tag,
                    })}
                    size={200}
                    logoImage={
                      'data:image/png;base64,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'
                    }
                    logoWidth={80}
                    logoHeight={20}
                    logoOpacity={1}
                  />
                </div>
                <div>{vehicleDetails?.tag}</div>
              </div>
            </div>
            <div className="my-3 d-flex align-items-center justify-content-center gap-2">
              <BaseButton
                onClick={() => {
                  exportAsImage(
                    thisQrcode.current!,
                    vehicleDetails?.registrationNumber + '-qrcode'
                  );
                }}
                loading={downloading}
              >
                <DownloadIcon />
                <span className="fs-12 ms-2">Download QR</span>
              </BaseButton>
              <WhiteButton
                onClick={() => {
                  CopyLnk('jdjdjjd');
                }}
              >
                <span className="fs-12 ms-3">
                  <CopyIcon />
                </span>
                <span className="fs-12 ms-2 me-3">Copy link</span>
              </WhiteButton>
            </div>
          </div>
        </div>
      </div>
      {editVehicle && (
        <EditVehicleComponent
          details={vehicleDetails!}
          onClose={() => setShowEditVehicle(null)}
        />
      )}
      {showDeleteVehicle && (
        <ConfirmDialogComponent
          loading={loading}
          message="This action is irreversible! <br/>Are you sure you want to delete this vehicle?"
          confirm={() => {
            DeleteVehicle();
          }}
          onClose={() => {
            setShowDeleteVehicle(false);
          }}
        />
      )}
    </div>
  );
}






  // const GetBusinessDetails = () => {
  //   setFetching(true);
  //   GetRequest(`${id}`, {}, false).then((res) => {
  //     if (res.status) {
  //       console.log('waiting for biz details', res)
  //       setBusinessDetails(res.data.business);
  //     }
  //   });
  // };
  // useEffect(() => {
  //   GetBusinessDetails();
  //   const details: string | null = localStorage.getItem(
  //     CONSTANTS.Routes.Businesses
  //   );
  //   if (details) {
  //     setBusinessDetails(JSON.parse(details));
  //   }
  // }, [businessDetails]);